jQuery(document).ready(function ($) {
    $('body').on('click', '[data-tab]', function () {
        $(".interface-tab.is-active").removeClass('is-active');
        $(".interface-tabs__button.is-active").removeClass('is-active');
        $(this).addClass('is-active');
        $('.interface-tab[data-tab-rel=' + $(this).data('tab') + ']').addClass('is-active');
    });
});